import Layout from '@/views/layout/index.vue'

const frameIn = [
    {
        path:'/',
        redirect:'/login',
    },
    
    {
        path: '/login', 
        component:()=> import('@/views/login/index.vue'), 
        hidden: true 
    },
    {
        path: '/items', 
        component:()=> import('@/views/dashboard/items.vue'), 
        hidden: true 
    },
    {
        path: '/xzt', 
        component:()=> import('@/views/xzt/index.vue'), 
        hidden: true 
    },
    {
        path: '/all', 
        component:()=> import('@/views/xzt/all.vue'), 
        hidden: true 
    },
    {
        path:'/statics',
        component:()=>import("@/views/statics/index_f.vue"),
        hidden:true
    },
    // {
    //     path:'/dashboard',
    //     component:Layout,
    //     redirect:'/dashboard/index',
    //     children:[
    //         {
    //             path:'/dashboard/index',
    //             component:()=>import('@/views/dashboard/index.vue')
    //         },
           
           
    //         {
    //             path:'/dashboard/banner_edit/:id?',
    //             component:()=>import('@/views/dashboard/banner_edit.vue')
    //         },
          
    //     ],
    //     hidden:true
    // },
    // {
    //     path:'/order',
    //     component:Layout,
    //     redirect:'/order/index',
    //     children:[
    //         {
    //             path:'/order/index',
    //             component:()=>import('@/views/order/index.vue')
    //         },
    //         {
    //             path:'/order/detail/:id',
    //             component:()=>import('@/views/order/detail.vue')
    //         }
    //     ]
    // },
    // {
    //     path:'/movie',
    //     component:Layout,
    //     redirect:'/movie/index',
    //     children:[
            
    //         {
    //             path:'/movie/index',
    //             component:()=>import('@/views/movie/category.vue')
    //         },
    //         {
    //             path:'/movie/category_edit/:id?',
    //             component:()=>import('@/views/movie/category_edit.vue')
    //         },
    //         {
    //             path:'/movie/lists',
    //             component:()=>import('@/views/movie/index.vue')
    //         },
    //         {
    //             path:'/movie/edit/:id?',
    //             component:()=>import('@/views/movie/edit.vue')
    //         },
    //     ],
    //     hidden:true
    // },
    // {
    //     path:'/links',
    //     component:Layout,
    //     redirect:'/links/index',
    //     children:[
           
    //         {
    //             path:'/links/index',
    //             component:()=>import('@/views/links/index.vue')
    //         },
    //         {
    //             path:'/links/edit/:id?',
    //             component:()=>import('@/views/links/edit.vue')
    //         },
          
    //     ],
    //     hidden:true
    // },
    // {
    //     path:'/message',
    //     component:Layout,
    //     redirect:'/message/index',
    //     children:[
    //         {
    //             path:'/message/index',
    //             component:()=>import('@/views/message/index.vue')
    //         }
    //     ]
    // },
    // {
    //     path:'/images',
    //     component:Layout,
    //     redirect:'/images/index',
    //     children:[
    //         {
    //             path:'/images/index',
    //             component:()=>import('@/views/images/index.vue')
    //         }
    //     ]
    // },
    // {
    //     path:'/manager',
    //     component:Layout,
    //     redirect:'/manager/index',
    //     children:[
    //         {
    //             path:'/manager/index',
    //             component:()=>import('@/views/manager/index.vue')
    //         }
    //     ]
    // },
]


export default [
    ...frameIn
];